import Reflux from 'reflux';

export default Reflux.createActions([
  'getList',
  'getListComplete',
  'changeList'
]);
